import { Database, ref, set } from 'firebase/database';

export const seasonSpanUpdate = async (
	database: Database,
	seasonSpan: { firstDay: string, lastDay: string }
): Promise<void> => {
	return set(ref(database, `settings/seasonSpan`), seasonSpan);
};
